import { render, staticRenderFns } from "./ModalReject.vue?vue&type=template&id=9798530c&"
import script from "./ModalReject.vue?vue&type=script&lang=js&"
export * from "./ModalReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports